import { Card, InlineGrid, SkeletonBodyText } from '@shopify/polaris';
import { memo } from 'react';

const SkeletonPricing = ({ elementCount = 4 }) => {
  return (
    <>
      <InlineGrid columns={{ xs: 1, md: 2, lg: 4 }} gap="400">
        {Array.from({ length: elementCount }, (_, index) => (
          <Card key={index}>
            <SkeletonBodyText lines={20} />
          </Card>
        ))}
      </InlineGrid>
    </>
  );
};

export default memo(SkeletonPricing);
